export interface BreadcrumbItem {
  text: string;
  to: string;
}

/**
 * A composable for managing breadcrumb navigation.
 * Uses Nuxt's useState to share breadcrumbs between pages and layout.
 */
export function useBreadcrumbs() {
  const breadcrumbs = useState<BreadcrumbItem[]>(
    'breadcrumbs',
    () => []
  );

  /** Clear all breadcrumbs */
  function clear() {
    breadcrumbs.value = [];
  }

  /** Set breadcrumbs to a specific list */
  function set(items: BreadcrumbItem[]) {
    breadcrumbs.value = items;
  }

  /** Add a single breadcrumb item to the end */
  function add(text: string, to: string) {
    breadcrumbs.value.push({ text, to });
  }

  /** Remove the last breadcrumb item */
  function removeLast() {
    breadcrumbs.value.pop();
  }

  return {
    breadcrumbs,
    clear,
    set,
    add,
    removeLast,
  };
}
